<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '~/stores/auth';
import { isNilOrEmpty } from '~/utils';

const props = defineProps({
  compromisso: {
    default: null,
    type: Object,
  },
});

const emit = defineEmits(['close', 'loaded', 'success', 'error']);

const authStore = useAuthStore();

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <div>
    <CompromissoJobCommandForm
      command="VerificarSubsidioCommand"
      :show-upload-files="false"
      :submit-button-disabled="!isNilOrEmpty(compromisso)
        && compromisso.responsavel.codigo !== authStore.codigoUsuario"
      :initial-model="{
        compromissoCodigos: props.compromisso ? [props.compromisso.codigo] : null,
      }"
      @close="() => emit('close')"
    >
      <template #form="{ model }">
        <a-form-item
          label="Foi atendido?"
          name="foiAtendido"
          :rules="{ required: true, message: 'Esse item é obrigatório' }"
        >
          <a-radio-group
            v-model:value="model.foiAtendido"
          >
            <a-radio-button :value="true">
              Sim
            </a-radio-button>
            <a-radio-button :value="false">
              Não
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </template>
    </CompromissoJobCommandForm>
  </div>
</template>
